import * as requestFromServer from './donationCrud';
import { donationSlice, callTypes } from './donationSlice';
import { actions as auth } from '../../../Auth/_redux/authRedux'
import { toastOption } from '../../../../../_metronic/_helpers/ToastHelpers'
import { toast } from 'react-toastify'
import axios from 'axios';
import { DonationURL } from '../../../../config/UrlEndPoint';
export const DONATION_URL = `${DonationURL}donation`;

const { actions } = donationSlice;

export const fetchDonations = (queryParams) => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.list }));
	return requestFromServer
		.findDonations(queryParams)
		.then(response => {
			// const { data: { total_items, items, donation_item_array } } = response.data;
			// dispatch(actions.donationsFetched({ total_items, items, donation_item_array }));
			const { data: { total_items, items } } = response.data;
			dispatch(actions.donationsFetched({ total_items, items }));
		}).catch(error => {
			if (error.response.status === 401) {
				toast.error(error.response.data.message, toastOption);
				dispatch(auth.logout())
			}
			error = error.response.data.message;
			dispatch(actions.catchError({ error, callType: callTypes.list }));
		});
};

export const fetchDonation = (id) => dispatch => {
	if (!id) {
		return dispatch(actions.donationFetched({ donationForEdit: undefined }));
	}

	dispatch(actions.startCall({ callType: callTypes.action }));
	return requestFromServer
		.getDonationById(id)
		.then(response => {
			// alias data to donation;
			const { data: donation } = response.data;
			dispatch(actions.donationFetched({ donationForEdit: donation }));
			return donation;
		}).catch(error => {
			if (error.response.status === 401) {
				toast.error(error.response.data.message, toastOption);
				dispatch(auth.logout())
			}
			error = error.response.data.message;
			dispatch(actions.catchError({ error, callType: callTypes.action }));
		});
};

export const getFileDonation = (fileId) => dispatch => {
	if (!fileId) {
		return dispatch(actions.donationFetched({ donationForEdit: undefined }));
	}

	dispatch(actions.startCall({ callType: callTypes.action }));
	return requestFromServer
		.getFileById(fileId)
		.then(response => {
			// alias data to donation;
			const { data } = response.data;
			return data;
		}).catch(error => {
			if (error.response.status === 401) {
				toast.error(error.response.data.message, toastOption);
				dispatch(auth.logout())
			}
			error = error.response.data.message;
			dispatch(actions.catchError({ error, callType: callTypes.action }));
		});
};

export const createDonation = (donationData) => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }));
	return requestFromServer
		.createDonation(donationData)
		.then(response => {
			dispatch(actions.donationReload);
			return response.data;
		})
		.catch(error => {
			if (error.response.status === 401) {
				toast.error(error.response.data.message, toastOption);
				dispatch(auth.logout())
			}
			error = error.response.data.message;
			dispatch(actions.catchError({ error, callType: callTypes.action }));
			toast.error(error)
		});
};

export const updateDonationItem = (donationItem, donationId) => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }));
	return requestFromServer
		.putDonationItem(donationItem, donationId)
		.then(response => {
			dispatch(actions.donationReload);
			return response.data;
		})
		.catch(error => {
			if (error.response.status === 401) {
				toast.error(error.response.data.message, toastOption);
				dispatch(auth.logout())
			}
			error = error.response.data.message;
			dispatch(actions.catchError({ error, callType: callTypes.action }));
		});
};

export const updateDonationPayment = (donationPayment, donationId) => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }));
	return requestFromServer
		.putDonationPayment(donationPayment, donationId)
		.then((response) => {
			toast.success(response.data.message, toastOption);
			dispatch(actions.donationReload);
			return response.data;
		})
		.catch((error) => {
			if (error.response.status === 401) {
				toast.error(error.response.data.message, toastOption);
				dispatch(auth.logout());
			}
			error = error.response.data.message;
			dispatch(actions.catchError({ error, callType: callTypes.action }));
		});
};

export const updateDonationDateChannel = (data, uuid) => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }));
	return requestFromServer
		.updateDonationDateChannel(data, uuid)
		.then(response => {
			dispatch(actions.donationReload);
			return response.data;
		})
		.catch(error => {
			if (error.response.status === 401) {
				toast.error(error.response.data.message, toastOption);
				dispatch(auth.logout())
			}
			error = error.response.data.message;
			dispatch(actions.catchError({ error, callType: callTypes.action }));
		});
};

export const updateDonationDepartment = (uuid, department_uuid) => dispatch => {
	console.log(uuid, department_uuid);
	dispatch(actions.startCall({ callType: callTypes.action }));
	return requestFromServer
		.updateDonationDepartment(uuid, department_uuid)
		.then(response => {
			dispatch(actions.donationReload);
			return response.data;
		})
		.catch(error => {
			if (error.response.status === 401) {
				toast.error(error.response.data.message, toastOption);
				dispatch(auth.logout())
			}
			error = error.response.data.message;
			dispatch(actions.catchError({ error, callType: callTypes.action }));
		});
};


export const downloadReport = (uuid, donation_hid) => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }));
	return axios.get(`${DONATION_URL}/print/${uuid}`, {
		responseType: 'arraybuffer',
		headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/pdf'
		},
		onDownloadProgress: (ProgressEvent) => {
			let percentCompleted = Math.floor(ProgressEvent.loaded / ProgressEvent.total * 100)
			dispatch(actions.startCall({ loadingProgress: percentCompleted }));
			return percentCompleted
		}
	})
		.then(response => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `Kuitansi Donasi ${donation_hid}.pdf`); //or any other extension
			document.body.appendChild(link);
			link.click();
		}).catch(error => {
			if (error?.response?.status === 401) {
				toast.error(error.response.data.message, toastOption);
				dispatch(auth.logout())
			}
			if (error?.response?.status === 404) {
				toast.error("File Tidak Ditemukan Di Server", toastOption);
			}
			console.log('====================================');
			console.log(error);
			console.log('====================================');
			error = error?.response?.data?.message;
			dispatch(actions.catchError({ error, callType: callTypes.action }));
		});
};

export const fetchDonationPayments = (queryParams) => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.list }));
	return requestFromServer
		.findDonationPayments(queryParams)
		.then(response => {
			// const { data: { total_items, items, donation_item_array } } = response.data;
			// dispatch(actions.donationsFetched({ total_items, items, donation_item_array }));
			const { data: { total_items, items } } = response.data;
			dispatch(actions.donationPaymentsFetched({ total_items, items }));
		}).catch(error => {
			if (error.response.status === 401) {
				toast.error(error.response.data.message, toastOption);
				dispatch(auth.logout())
			}
			error = error.response.data.message;
			dispatch(actions.catchError({ error, callType: callTypes.list }));
		});
};
